export const ALL_OPTION = 'Tutti'

const OTHER_REGION = 'Altra'

/** Italian province code -> [province name, region]. */
const PROVINCES: Record<string, [string, string]> = {
  AG: ['AGRIGENTO', 'Sicilia'],
  AL: ['ALESSANDRIA', 'Piemonte'],
  AN: ['ANCONA', 'Marche'],
  AO: ['AOSTA', "Valle d'Aosta"],
  AP: ['ASCOLI PICENO', 'Marche'],
  AQ: ["L'AQUILA", 'Abruzzo'],
  AR: ['AREZZO', 'Toscana'],
  AT: ['ASTI', 'Piemonte'],
  AV: ['AVELLINO', 'Campania'],
  BA: ['BARI', 'Puglia'],
  BG: ['BERGAMO', 'Lombardia'],
  BI: ['BIELLA', 'Piemonte'],
  BL: ['BELLUNO', 'Veneto'],
  BN: ['BENEVENTO', 'Campania'],
  BO: ['BOLOGNA', 'Emilia-Romagna'],
  BR: ['BRINDISI', 'Puglia'],
  BS: ['BRESCIA', 'Lombardia'],
  BT: ['BARLETTA-ANDRIA-TRANI', 'Puglia'],
  BZ: ['BOLZANO', 'Trentino-Alto Adige'],
  CA: ['CAGLIARI', 'Sardegna'],
  CB: ['CAMPOBASSO', 'Molise'],
  CE: ['CASERTA', 'Campania'],
  CH: ['CHIETI', 'Abruzzo'],
  CL: ['CALTANISSETTA', 'Sicilia'],
  CN: ['CUNEO', 'Piemonte'],
  CO: ['COMO', 'Lombardia'],
  CR: ['CREMONA', 'Lombardia'],
  CS: ['COSENZA', 'Calabria'],
  CT: ['CATANIA', 'Sicilia'],
  CZ: ['CATANZARO', 'Calabria'],
  EN: ['ENNA', 'Sicilia'],
  FC: ['FORLÌ-CESENA', 'Emilia-Romagna'],
  FE: ['FERRARA', 'Emilia-Romagna'],
  FG: ['FOGGIA', 'Puglia'],
  FI: ['FIRENZE', 'Toscana'],
  FM: ['FERMO', 'Marche'],
  FR: ['FROSINONE', 'Lazio'],
  GE: ['GENOVA', 'Liguria'],
  GO: ['GORIZIA', 'Friuli-Venezia Giulia'],
  GR: ['GROSSETO', 'Toscana'],
  IM: ['IMPERIA', 'Liguria'],
  IS: ['ISERNIA', 'Molise'],
  KR: ['CROTONE', 'Calabria'],
  LC: ['LECCO', 'Lombardia'],
  LE: ['LECCE', 'Puglia'],
  LI: ['LIVORNO', 'Toscana'],
  LO: ['LODI', 'Lombardia'],
  LT: ['LATINA', 'Lazio'],
  LU: ['LUCCA', 'Toscana'],
  MB: ['MONZA E DELLA BRIANZA', 'Lombardia'],
  MC: ['MACERATA', 'Marche'],
  ME: ['MESSINA', 'Sicilia'],
  MI: ['MILANO', 'Lombardia'],
  MN: ['MANTOVA', 'Lombardia'],
  MO: ['MODENA', 'Emilia-Romagna'],
  MS: ['MASSA-CARRARA', 'Toscana'],
  MT: ['MATERA', 'Basilicata'],
  NA: ['NAPOLI', 'Campania'],
  NO: ['NOVARA', 'Piemonte'],
  NU: ['NUORO', 'Sardegna'],
  OR: ['ORISTANO', 'Sardegna'],
  PA: ['PALERMO', 'Sicilia'],
  PC: ['PIACENZA', 'Emilia-Romagna'],
  PD: ['PADOVA', 'Veneto'],
  PE: ['PESCARA', 'Abruzzo'],
  PG: ['PERUGIA', 'Umbria'],
  PI: ['PISA', 'Toscana'],
  PN: ['PORDENONE', 'Friuli-Venezia Giulia'],
  PO: ['PRATO', 'Toscana'],
  PR: ['PARMA', 'Emilia-Romagna'],
  PT: ['PISTOIA', 'Toscana'],
  PU: ['PESARO E URBINO', 'Marche'],
  PV: ['PAVIA', 'Lombardia'],
  PZ: ['POTENZA', 'Basilicata'],
  RA: ['RAVENNA', 'Emilia-Romagna'],
  RC: ['REGGIO CALABRIA', 'Calabria'],
  RE: ['REGGIO EMILIA', 'Emilia-Romagna'],
  RG: ['RAGUSA', 'Sicilia'],
  RI: ['RIETI', 'Lazio'],
  RM: ['ROMA', 'Lazio'],
  RN: ['RIMINI', 'Emilia-Romagna'],
  RO: ['ROVIGO', 'Veneto'],
  SA: ['SALERNO', 'Campania'],
  SI: ['SIENA', 'Toscana'],
  SO: ['SONDRIO', 'Lombardia'],
  SP: ['LA SPEZIA', 'Liguria'],
  SR: ['SIRACUSA', 'Sicilia'],
  SS: ['SASSARI', 'Sardegna'],
  SU: ['SUD SARDEGNA', 'Sardegna'],
  SV: ['SAVONA', 'Liguria'],
  TA: ['TARANTO', 'Puglia'],
  TE: ['TERAMO', 'Abruzzo'],
  TN: ['TRENTO', 'Trentino-Alto Adige'],
  TO: ['TORINO', 'Piemonte'],
  TP: ['TRAPANI', 'Sicilia'],
  TR: ['TERNI', 'Umbria'],
  TS: ['TRIESTE', 'Friuli-Venezia Giulia'],
  TV: ['TREVISO', 'Veneto'],
  UD: ['UDINE', 'Friuli-Venezia Giulia'],
  VA: ['VARESE', 'Lombardia'],
  VB: ['VERBANO-CUSIO-OSSOLA', 'Piemonte'],
  VC: ['VERCELLI', 'Piemonte'],
  VE: ['VENEZIA', 'Veneto'],
  VI: ['VICENZA', 'Veneto'],
  VR: ['VERONA', 'Veneto'],
  VT: ['VITERBO', 'Lazio'],
  VV: ['VIBO VALENTIA', 'Calabria'],
}

const PROVINCE_ENTRIES = Object.values(PROVINCES)
const REGION_BY_PROVINCE_NAME = new Map(PROVINCE_ENTRIES)
const PROVINCE_NAMES_LONGEST_FIRST = PROVINCE_ENTRIES.map(([name]) => name).sort((a, b) => b.length - a.length)

export const withAllOption = (values: Iterable<string>) => [ALL_OPTION, ...Array.from(new Set(values)).sort()]

export const REGION_OPTIONS = withAllOption(PROVINCE_ENTRIES.map(([, region]) => region))

export const getProvinceOptions = (region: string) =>
  withAllOption(PROVINCE_ENTRIES.filter(([, r]) => region === ALL_OPTION || r === region).map(([name]) => name))

/** Accepts the dirty `provincia` values stored on sites: codes, full names, or text containing either. */
const getProvinceName = (rawProvince: string | null): string => {
  const words = rawProvince?.toUpperCase().match(/[A-ZÀ-Ú]+/g) ?? []

  const fullName = words.find((word) => REGION_BY_PROVINCE_NAME.has(word))
  if (fullName) return fullName

  const code = words.find((word) => PROVINCES[word])
  if (code) return PROVINCES[code][0]

  const text = words.join(' ')
  return PROVINCE_NAMES_LONGEST_FIRST.find((name) => text.includes(name)) ?? ''
}

export const resolveProvince = (rawProvince: string | null) => {
  const name = getProvinceName(rawProvince)
  return {
    provinceName: name || rawProvince?.toUpperCase().trim() || '',
    region: REGION_BY_PROVINCE_NAME.get(name) ?? OTHER_REGION,
  }
}
